import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getExpireTime, getRememberMe } from '../Utils/AuthUtil';

function SessionGuard() {
	const navigate = useNavigate();

	useEffect(() => {
		const expireTime = getExpireTime();
		const rememberMe = parseInt(getRememberMe() || '0', 10);

		if (!expireTime || isNaN(rememberMe)) {
			return;
		}

		if (expireTime !== null && (rememberMe === 0 || rememberMe === 2)) {
			const now = Date.now();
			const expireTimestamp = parseInt(expireTime, 10);

			if (!isNaN(expireTimestamp) && now > expireTimestamp) {
				localStorage.clear();
				navigate('/');
			}
		}
	}, [navigate]);

	return null;
}

export default SessionGuard;
